import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function UykuTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['uyku-testi']} />;
}
